import {
    Component,
    ComponentFactoryResolver,
    ComponentRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewContainerRef
} from '@angular/core';
import {PhotoComment} from '../../../../shared/models/cameralla-comment.model';
import {CommentReplyComponent} from "../comment-reply/comment-reply.component";
import {ReplyCommentService} from "../services/reply-comment.service";
import {ToastrService} from "ngx-toastr";

import {CamerallaAuthService} from "../../../../shared/services/authentication-services/cameralla-auth.service";
import {Photo} from "../../../../shared/models/cameralla-photo.model";
import {UserComments} from "../../services/user-comments.service";
import { RatingService } from "../../services/rating.service";
import AppShareHelper from "../../../../shared/utils/helper";
import { TranslateService } from "../../../../shared/services/translate.service";

@Component({
    selector: 'app-comment',
    templateUrl: './comment.component.html',
})
export class CommentComponent implements OnInit, OnChanges {
    @Input() photoComments: PhotoComment[];
    @Input() group:any;
    @Input() ratings:any;
    @Input() ownerPhoto: any;
    criterion = ['general', 'vision', 'composition', 'cameraSettings', 'editing', 'presentation'];
    @Input() tabActive;
    @Output() onRefresh: EventEmitter<any> = new EventEmitter<any>();
    count;
    userId;
    selectedCriteria = this.tabActive;
    maxLength = 1000;

    private componentInstance: ComponentRef<CommentReplyComponent> = null;

    constructor(private viewContainerRef: ViewContainerRef,
                private componentFactoryResolver: ComponentFactoryResolver,
                private replyCommentService: ReplyCommentService,
                private userCommentsService: UserComments,
                private translateService: TranslateService,
                private ratingService: RatingService,
                private toastr: ToastrService,
                private authService: CamerallaAuthService) {
    }

    ngOnInit() {
        this.selectedCriteria = this.tabActive;
        let activeTab = this.tabActive.substring(0, this.tabActive.indexOf('_'));
        this.setCommentView(activeTab);
        this.userId = +this.authService.getLocalUserInfo()['id'];
        this.ratings = this.ratings || Photo.getDefaultRating({});
    }

    public currentEditInlineComment:any = {
        "id": ''
    };

    public manageEditInlineComment:any ={

    };
    
    
    public translationButtonText(comment) {
        return AppShareHelper.translationButtonText(comment);
    }
    
    removeComment(comment) {
        if (confirm('Are you sure you want to remove this comment?')) {
            this.replyCommentService.removeComment(comment.id).subscribe(()=> {
                //this.toastr.success('Remove comment successfully', "Done");
                this.onRefresh.emit();
            }, (e) => {
                this.toastr.error('Remove comment fail', "Error");
            })
        }
    }
    
    removeParentComment(comment) {
        if (confirm('Are you sure you want to remove this comment?')) {
            this.ratingService.removeComment(comment.id).subscribe(()=> {
                //this.toastr.success('Remove comment successfully', "Done");
                this.onRefresh.emit();
            }, (e) => {
                this.toastr.error('Remove comment fail', "Error");
            })
        }
    }

    updateComment(e?, isComment?, value?){
        if (value) {
            if (e && e.which == 13 && !e.shiftKey) {
                e.preventDefault();
                this.checkIsReply(isComment, value);
            }

            if (!e) {
                this.checkIsReply(isComment, value);
            }
        }
    }

    checkIsReply(isComment, value) {
        let condition = '';

        if (isComment) {
            condition = this.currentEditInlineComment.general_text = value;
        } else {
            condition = this.currentEditInlineComment.content = value;
        }

        if (condition.trim().length > 0) {
            const request = isComment ? this.ratingService.updateRating(this.currentEditInlineComment, this.currentEditInlineComment.id) : this.replyCommentService.updateComment(this.currentEditInlineComment);
            request.subscribe((data:any)=> {
                this.destroyComponent(this.currentEditInlineComment, isComment)
            });
        }
    }

    editComment(comment, isComment?){
        this.currentEditInlineComment = AppShareHelper.deepClone(this.currentEditInlineComment);
        if (this.currentEditInlineComment.id != '') {
            this.manageEditInlineComment[(isComment ? 'comment' : 'replyComment') + this.currentEditInlineComment.id] = false;
        }

        this.manageEditInlineComment[(isComment ? 'comment' : 'replyComment') + comment.id] = true;
        this.manageEditInlineComment[(isComment ? 'commentInfo' : 'replyCommentInfo') + comment.id] = isComment ? comment.general_text : comment.content;

        this.currentEditInlineComment = comment;
    }

    reply(event, srcComment, type, isChild?) {
        if (this.componentInstance) {
            this.componentInstance.destroy();
        }
        
        setTimeout(res => {
            this.createLoaderComponent();
            setTimeout(() => {
                this.makeComponentAChild(event, isChild);
    
                this.componentInstance.instance.srcComment = {
                    ratingId: srcComment.id,
                    commentType: type
                };
    
                this.componentInstance.instance.onSend.subscribe(data => {
                    // Send Notification.
                    if (data) {
                        const ratingData = {
                            content: data.content,
                            photoId: srcComment.photoId,
                            modelId: srcComment.id
                        };
                        this.userCommentsService.sendMessage([srcComment], this.ownerPhoto, this.userId, ratingData, this.group);
                    }
        
                    try {
                        this.componentInstance.destroy();
                        this.onRefresh.emit();
                    } catch (e) {
                        console.log(e);
                    }
                });
            }, 100)
        }, 100);
    }
    
    markAsUseful(event, srcComment) {
        const commentModel = AppShareHelper.deepClone(srcComment);
        if (commentModel.originalComment) {
            commentModel.general_text = srcComment.originalComment;
        }
        commentModel.isUseful = true;
        this.ratingService.updateRating(commentModel, commentModel.id).subscribe((res) => {
            this.onRefresh.emit();
        })
    }
    
    translate(event, srcComment, commentKey = 'general_text') {
        if (srcComment.originalComment) {
            srcComment[commentKey] = srcComment.originalComment;
            delete srcComment.originalComment;
        } else {
            this.translateService.translate(srcComment[commentKey], navigator.language).toPromise().then((res: any) => {
                srcComment.originalComment = srcComment[commentKey];
                srcComment[commentKey] = res.data && res.data.translations ? res.data.translations[0].translatedText : srcComment[commentKey];
            })
        }
    }

    private destroyComponent(comment, isComment?) {
        this.manageEditInlineComment[(isComment ? 'comment' : 'replyComment') + comment.id] = false;
    }

    private createLoaderComponent() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CommentReplyComponent);
        this.componentInstance = this.viewContainerRef.createComponent(componentFactory);
    }

    private makeComponentAChild(event, isChild?) {
        const loaderComponentElement = this.componentInstance.location.nativeElement;
        event.target.parentNode.appendChild(loaderComponentElement);
        if (isChild) {
            event.target.parentNode.parentNode.parentNode.appendChild(loaderComponentElement);
        }
    }

    myRating(comment) {
        return AppShareHelper.getViewRatingPoint(comment[this.criterion[0]] || 0);
    }

    setCommentView(criteria) {
        this.selectedCriteria = criteria;
        //this.commentCount();
    }

    commentCount() {
        this.count = this.photoComments.length;
        return this.count;
    }

    ngOnChanges(changes: SimpleChanges) {
        this.commentCount();
    }
}
